/* eslint-disable import/namespace */
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
} from "chart.js";
import _ from "lodash";
import React from "react";
import { Bar, Doughnut } from "react-chartjs-2";
import styled from "styled-components";

import { Text } from "@components/Text";
import { getChartOptions } from "@utils/getChartOptions";

ChartJS.register(
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const Container = styled.div`
  display: grid;
  gap: 16px;
  grid-template-columns: 2.5fr 1fr;
  min-height: 336px;
  flex-shrink: 0;
`;

const ContainerBlock = styled.div`
  width: 100%;
  height: 100%;
  padding: 16px;
  gap: 16px;
  border-radius: 16px;
  background: white;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: white;
  box-sizing: border-box;
`;

const ContainerChart = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 16px;
  background: white;
  display: flex;
  gap: 16px;
  flex-direction: column;
  padding: 16px;
  box-sizing: border-box;
`;

const ContainerLayoutChart = styled.div`
  position: relative;
  height: 336px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const InnerDoughnutChart = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 45%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const OverviewChart = ({ overviewChartData = null }) => {
  const barChartDataSource = _.chain(overviewChartData)
    .get(["top10CampaignsByProject"])
    .thru((data) => {
      const chartData = _.map(data, (item) => {
        return {
          labels: _.get(item, ["location_name"]),
          value: _.get(item, ["totalCampaigns"]),
        };
      });

      const chartLabels = _.map(chartData, "labels");
      const chartValue = _.map(chartData, (item, index) => {
        return _.chain(item).get(["value"]).toInteger().value();
      });

      const source = {
        labels: chartLabels,
        datasets: [
          {
            data: chartValue,
            backgroundColor: "#0CD6A4",
            borderColor: "#02B286",
            borderWidth: 1,
            borderRadius: 8,
            barThickness: 36,
            barPercentage: 1,
          },
        ],
      };
      return source;
    })
    .value();

  const doughnutChartDataSource = _.chain(overviewChartData)
    .get(["filesPerProject"])
    .thru((data) => {
      const source = {
        labels: ["Image", "Video", "Audio"],
        datasets: [
          {
            label: "Files",
            data: [
              _.get(data, ["total_images"]),
              _.get(data, ["total_videos"]),
              _.get(data, ["total_audios"]),
            ],
            backgroundColor: ["#00CC99", "#B5E48C", "#1A759F"],
            borderWidth: 1,
          },
        ],
      };
      return source;
    })
    .value();

  const barChartOptions = getChartOptions({ chartType: "barChart" });
  const doughnutChartOptions = getChartOptions({ chartType: "doughnut" });
  const totalFiles = _.chain(overviewChartData)
    .get(["filesPerProject"])
    .values()
    .map(Number)
    .sum()
    .value();

  return (
    <Container>
      <ContainerBlock>
        <ContainerChart>
          <Text style={{ width: "100%" }} fontSize={"20px"} fontWeight="600">
            TOP 10 Campaigns by Project
          </Text>
          {_.has(barChartDataSource, "labels") &&
            _.has(barChartDataSource, "datasets") && (
              <ContainerLayoutChart>
                <Bar data={barChartDataSource} options={barChartOptions} />
              </ContainerLayoutChart>
            )}
        </ContainerChart>
      </ContainerBlock>
      <ContainerBlock>
        <ContainerChart>
          <Text style={{ width: "100%" }} fontSize={"20px"} fontWeight="600">
            Files Per Project
          </Text>
          {_.has(doughnutChartDataSource, "labels") &&
            _.has(doughnutChartDataSource, "datasets") && (
              <ContainerLayoutChart>
                <Doughnut
                  data={doughnutChartDataSource}
                  options={doughnutChartOptions}
                />
                <InnerDoughnutChart>
                  <Text align="center" fontSize={"14px"} fontWeight="400">
                    Total Files
                  </Text>
                  <Text align="center" fontSize={"20px"} fontWeight="600">
                    {totalFiles}
                  </Text>
                </InnerDoughnutChart>
              </ContainerLayoutChart>
            )}
        </ContainerChart>
      </ContainerBlock>
    </Container>
  );
};
